export const validateEmail = (email: string) => {
  const emailReg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  const emailValue = email.trim();

  return emailReg.test(emailValue);
};

export const validatePassword = (password: string) => {
  const pswdReg = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%&*]).{8,30}$/;

  return pswdReg.test(password);
};

export const validatePhone = (phoneNo: string) => {
  const phoneReg = /^\(?\+?[0-9]{0,3}\)?\d+$/;

  return phoneReg.test(phoneNo);
};

export const checkIsEuropeCountry = (country?: string) => {
  let vatMemList = window.signupData?.vatMemberStates || 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,MC,NL,PL,PT,RO,SK,SI,ES,SE,GB';
  window.signupData = { ...window.signupData, vatMemberStates: vatMemList };

  let { currentCountry, vatMemberStates } = window.signupData;
  if (country && vatMemberStates) return !!vatMemberStates?.toLocaleLowerCase()?.includes(country?.toLocaleLowerCase() ?? '');
  else if (currentCountry && vatMemberStates) return !!vatMemberStates?.toLocaleLowerCase()?.includes(currentCountry?.toLocaleLowerCase() ?? '');
  return false;
};

export const checkVATNumberFormat = (vatNumber: string, countryCode: string) => {
  var valid = false;
  var patt;

  switch (countryCode) {
    case 'AT':
      patt = new RegExp('^(AT)?U[0-9]{8}$');
      break;
    case 'BE':
      patt = new RegExp('^(BE)?0[0-9]{9}$');
      break;
    case 'BG':
      patt = new RegExp('^(BG)?[0-9]{9,10}$');
      break;
    case 'CY':
      patt = new RegExp('^(CY)?[0-9]{8}L$');
      break;
    case 'CZ':
      patt = new RegExp('^(CZ)?[0-9]{8,10}$');
      break;
    case 'DE':
      patt = new RegExp('^(DE)?[0-9]{9}$');
      break;
    case 'DK':
      patt = new RegExp('^(DK)?[0-9]{8}$');
      break;
    case 'EE':
      patt = new RegExp('^(EE)?[0-9]{9}$');
      break;
    case 'GR':
      patt = new RegExp('^(EL|GR)?[0-9]{9}$');
      break;
    case 'ES':
      patt = new RegExp('^(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]$');
      break;
    case 'FI':
      patt = new RegExp('^(FI)?[0-9]{8}$');
      break;
    case 'FR':
      patt = new RegExp('^(FR)?[0-9A-Z]{2}[0-9]{9}$');
      break;
    case 'GB':
      patt = new RegExp('^(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$');
      break;
    case 'HU':
      patt = new RegExp('^(HU)?[0-9]{8}$');
      break;
    case 'IE':
      patt = new RegExp('^(IE)?[A-Z0-9]{8,9}$');
      break;
    case 'IT':
      patt = new RegExp('^(IT)?[0-9]{11}$');
      break;
    case 'LT':
      patt = new RegExp('^(LT)?([0-9]{9}|[0-9]{12})$');
      break;
    case 'LU':
      patt = new RegExp('^(LU)?[0-9]{8}$');
      break;
    case 'LV':
      patt = new RegExp('^(LV)?[0-9]{11}$');
      break;
    case 'MT':
      patt = new RegExp('^(MT)?[0-9]{8}$');
      break;
    case 'NL':
      patt = new RegExp('^(NL)?[0-9]{9}B[0-9]{2}$');
      break;
    case 'PL':
      patt = new RegExp('^(PL)?[0-9]{10}$');
      break;
    case 'PT':
      patt = new RegExp('^(PT)?[0-9]{9}$');
      break;
    case 'RO':
      patt = new RegExp('^(RO)?[0-9]{2,10}$');
      break;
    case 'SE':
      patt = new RegExp('^(SE)?[0-9]{12}$');
      break;
    case 'SI':
      patt = new RegExp('^(SI)?[0-9]{8}$');
      break;
    case 'SK':
      patt = new RegExp('^(SK)?[0-9]{10}$');
      break;
    case 'MC':
      //Monaco - Same as France
      patt = new RegExp('^(FR)?[0-9A-Z]{2}[0-9]{9}$');
      break;
    case 'HR':
      //Croatia - 11 digit number (ex. HR12345678901)
      patt = new RegExp('^(HR)?[0-9]{11}$');
      break;
  }
  if (patt !== undefined) {
    valid = patt.test(vatNumber);
  }
  return valid;
};

export const runCheck = (checklist: { [key: string]: () => boolean }) => {
  let isValid = true;

  Object.entries(checklist).forEach(([_, fn]) => {
    if (!fn()) isValid = false;
  });

  return isValid;
};

const removeEmpty = (obj: any) => {
  let newObj: any = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === Object(obj[key])) newObj[key] = removeEmpty(obj[key]);
    else if (obj[key] !== undefined) newObj[key] = obj[key];
  });
  return newObj;
};

export type IgnoreList = ('personal' | 'billingAndDelivery' | 'preferencesAndMembership' | 'accountAndTax')[];

export const getUserData = (params?: { ignoreList?: IgnoreList; registeredUserID?: string; businessPartnerNo?: string; isNewUser?: boolean }) => {
  let { personal, billingAndDelivery, preferencesAndMembership, accountAndTax, currentCountry } = window.signupData;

  if (params?.ignoreList) {
    if (params.ignoreList.includes('personal')) {
      personal = window.signupData.originalPersonal;
    }

    if (params.ignoreList.includes('billingAndDelivery')) {
      billingAndDelivery = window.signupData.originalBillingAndDelivery;
    }

    if (params.ignoreList.includes('preferencesAndMembership')) {
      preferencesAndMembership = window.signupData.originalPreferencesAndMembership;
    }

    if (params.ignoreList.includes('accountAndTax')) {
      accountAndTax = window.signupData.originalAccountAndTax;
    }
  }

  if (!personal || !billingAndDelivery) return;

  let { billingDetail, deliveryDetail, deliveryRegion } = billingAndDelivery;

  const phoneMobile = (billingDetail.phoneCode ? billingDetail.phoneCode + '-' : '') + billingDetail.phone;

  const newCustomer: any = {
    type: 'NewCustomerRO',
    user: {
      email: personal.email,
      title: personal.title,
      type: personal.lastName || personal.firstName ? 'UserRO' : undefined,
      firstName: personal.firstName,
      lastName: personal.lastName,
      businessPartnerNo: params?.businessPartnerNo,
    },
    credentials: {
      type: personal.email ? 'CredentialsRO' : undefined,
      login: personal.email,
      password: personal.password,
    },
    address: {
      phoneMobile: phoneMobile,
      addressLine1: billingDetail.addressLine1,
      type: billingDetail.addressLine1 ? 'AddressRO' : undefined,
      postalCode: billingDetail.postalCode,
      countryCode: billingDetail.country,
      state: billingDetail.state,
      city: billingDetail.city,
      addressLine2: billingDetail.addressLine2,
      firstName: personal.firstName,
      lastName: personal.lastName,
    },
    shippingAddress: {
      type: 'ShippingAddressRO',
      firstName: personal.firstName,
      lastName: personal.lastName,
      addressLine1: deliveryDetail.addressLine1,
      addressLine2: deliveryDetail.addressLine2,
      city: deliveryDetail.city,
      state: deliveryDetail.state,
      postalCode: deliveryDetail.postalCode,
      countryCode: deliveryDetail.country,
      preferredShippingAddress: true,
      phoneMobile: phoneMobile,
    },
    userAttributes: {
      organisationName: preferencesAndMembership?.company,
      positionInOrganisation: preferencesAndMembership?.position,
      industry: preferencesAndMembership?.industry,
      preferredPublisher: preferencesAndMembership?.publisher,
      acceptTermsAndConditions: personal.checkboxIAgree ? 'true' : 'false',
      deliveryRegion: deliveryRegion,
      isAllComms: preferencesAndMembership?.checkboxPromotions ? 'false' : 'true',
      isMail: billingDetail.isoAlpha,
      isOtherComms: deliveryDetail.isoAlpha,
      isEmail: 'REGION_PLACEHOLDER',
      registeredUserID: params?.registeredUserID,
      cancelledOrder: params?.isNewUser ? '' : undefined,
    },
    customerNo: '00000000',
    companyName: 'Default',
    optin: preferencesAndMembership?.checkboxPromotions ? 'true' : 'false',
  };

  if (checkIsEuropeCountry()) {
    newCustomer.userAttributes.notRegistered = accountAndTax?.haveVat ? 'false' : 'true';
    newCustomer.userAttributes.exempt = accountAndTax?.haveVat ? 'true' : 'false';
    newCustomer.userAttributes.memberCountryCode = currentCountry;
    newCustomer.userAttributes.verified = accountAndTax?.haveVat ? 'true' : 'false';
    newCustomer.userAttributes.VatNumber = accountAndTax?.haveVat ? accountAndTax.vatNumber : '';
  }

  return removeEmpty(newCustomer);
};
